import type { BuildGlobals } from "./buildGlobals";

type BuildInfo = {
  version: string;
  sha: string;
  buildTime: string;
};

const g = globalThis as typeof globalThis & BuildGlobals;

export const BUILD_INFO: BuildInfo = {
  version: g.__APP_VERSION__ ?? "test",
  sha: g.__GIT_SHA__ ?? "test",
  buildTime: g.__BUILD_TIME__ ?? new Date(0).toISOString(),
};
